export const gr20 = "GR20";
export const gr30 = "GR30";

export function trimGR20Only(gradeInfo) {
    return gradeInfo.filter((info) => info.CD !== gr20);
}

export function trimGR30Only(gradeInfo) {
    return gradeInfo.filter((info) => info.CD !== gr30);
}

export function trimGR20(gradeInfo) {
    return gradeInfo.filter((info) => info.CD !== gr20 && info.CD !== gr30);
}

export function extractGR20(gradeInfo) {
    return gradeInfo.filter((info) => info.CD === gr20 || info.CD !== gr20);
}
// export function extractGR20(gradeInfo) {
//     return gradeInfo.filter((info) => info.CD === gr20);
// }

export default trimGR20;
